/* TM LUX TILE — gallery swipe + stagger load for shared product tiles.
   Extracted from sections/collection-grid-v2.liquid (behavior unchanged)
   so homepage sections get identical tile behavior. Multiple sections may
   load this asset on one page: initialization is guarded per-gallery. */
(function () {
  'use strict';

  var GRID_SELECTOR = '.tmv2-grid, [data-tmlux-tiles]';
  var THRESHOLD     = 5;
  var SWIPE_MIN     = 40;
  var SLIDE_TR      = 'transform 280ms cubic-bezier(0.25,0.46,0.45,0.94)';
  var SNAP_TR       = 'transform 200ms cubic-bezier(0.25,0.46,0.45,0.94)';

  function initGrid(grid) {
    if (grid.getAttribute('data-tmv2-swipe') === 'false') return;
    var galleries = grid.querySelectorAll('[data-tmv2-gallery]');
    galleries.forEach(function (media) {
      if (media.dataset.tmluxInit) return;
      media.dataset.tmluxInit = '1';
      var imgs = Array.prototype.slice.call(media.querySelectorAll('.tmv2-media__img'));
      var dots = Array.prototype.slice.call(media.querySelectorAll('.tmv2-dot'));
      if (imgs.length <= 1) return;

      var imgPos = imgs.map(function (_, i) { return i === 0 ? 0 : 100; });
      var state     = { currentIndex: 0, startX: 0, startY: 0, lock: null };
      var dragState = { staged: false, dir: 0, nxtIndex: -1 };

      imgs.forEach(function (img, i) {
        img.style.transition = 'none';
        img.style.transform  = i === 0 ? 'translateX(0)' : 'translateX(100%)';
      });

      function freezeImg(img, w) {
        var s = getComputedStyle(img).transform;
        img.style.transition = 'none';
        if (s && s !== 'none') {
          var m = s.match(/matrix\([^,]+,[^,]+,[^,]+,[^,]+,\s*([-\d.]+)/);
          if (m && w) return parseFloat(m[1]) / w * 100;
        }
        return null;
      }

      function stageNext(dir) {
        var ni = state.currentIndex + dir;
        if (ni < 0 || ni >= imgs.length) return false;
        dragState.staged   = true;
        dragState.dir      = dir;
        dragState.nxtIndex = ni;
        imgPos[ni]              = dir > 0 ? 100 : -100;
        imgs[ni].style.transition = 'none';
        imgs[ni].style.transform  = 'translateX(' + imgPos[ni] + '%)';
        return true;
      }

      function moveLive(dx) {
        var w   = media.offsetWidth || 200;
        var pct = (dx / w) * 100;
        if (!dragState.staged) {
          var rb = pct * 0.18;
          imgs[state.currentIndex].style.transition = 'none';
          imgs[state.currentIndex].style.transform  = 'translateX(' + rb + '%)';
          return;
        }
        imgPos[state.currentIndex] = pct;
        imgs[state.currentIndex].style.transition = 'none';
        imgs[state.currentIndex].style.transform  = 'translateX(' + pct + '%)';
        var ni  = dragState.nxtIndex;
        var off = dragState.dir > 0 ? 100 : -100;
        imgPos[ni] = off + pct;
        imgs[ni].style.transition = 'none';
        imgs[ni].style.transform  = 'translateX(' + imgPos[ni] + '%)';
      }

      function commitSlide() {
        var dir = dragState.dir;
        var ci  = state.currentIndex;
        var ni  = dragState.nxtIndex;
        imgPos[ci] = -dir * 100;
        imgs[ci].style.transition = SLIDE_TR;
        imgs[ci].style.transform  = 'translateX(' + imgPos[ci] + '%)';
        imgPos[ni] = 0;
        imgs[ni].style.transition = SLIDE_TR;
        imgs[ni].style.transform  = 'translateX(0)';
        dots[ci] && dots[ci].classList.remove('is-on');
        state.currentIndex = ni;
        dots[state.currentIndex] && dots[state.currentIndex].classList.add('is-on');
        dragState.staged = false; dragState.dir = 0; dragState.nxtIndex = -1;
      }

      function snapBack() {
        var ci = state.currentIndex;
        imgPos[ci] = 0;
        imgs[ci].style.transition = SNAP_TR;
        imgs[ci].style.transform  = 'translateX(0)';
        if (dragState.staged && dragState.nxtIndex >= 0) {
          var ni    = dragState.nxtIndex;
          var toOff = dragState.dir > 0 ? 100 : -100;
          imgPos[ni] = toOff;
          imgs[ni].style.transition = SNAP_TR;
          imgs[ni].style.transform  = 'translateX(' + toOff + '%)';
        }
        dragState.staged = false; dragState.dir = 0; dragState.nxtIndex = -1;
      }

      function onStart(x, y) {
        var w = media.offsetWidth || 200;
        imgs.forEach(function (img, i) {
          var pos = freezeImg(img, w);
          if (pos !== null) {
            imgPos[i] = pos;
            img.style.transform = 'translateX(' + pos + '%)';
          } else {
            img.style.transition = 'none';
          }
        });
        state.startX = x; state.startY = y; state.lock = null;
        dragState.staged = false; dragState.dir = 0; dragState.nxtIndex = -1;
      }

      function onMove(x, y, evt) {
        var dx = x - state.startX;
        var dy = y - state.startY;
        if (!state.lock) {
          if (Math.abs(dx) > THRESHOLD || Math.abs(dy) > THRESHOLD) {
            state.lock = Math.abs(dx) > Math.abs(dy) * 1.2 ? 'horizontal' : 'vertical';
          }
        }
        if (state.lock === 'horizontal') {
          if (evt) { evt.stopPropagation(); if (evt.cancelable) evt.preventDefault(); }
          if (!dragState.staged) stageNext(dx < 0 ? 1 : -1);
          moveLive(dx);
        }
      }

      function onEnd(x) {
        if (state.lock === 'horizontal') {
          var dx = x - state.startX;
          if (Math.abs(dx) >= SWIPE_MIN && dragState.staged) {
            commitSlide();
          } else {
            snapBack();
          }
        } else if (dragState.staged) {
          snapBack();
        }
        state.lock = null;
        if (dragState.staged) { dragState.staged = false; dragState.dir = 0; dragState.nxtIndex = -1; }
      }

      function onCancel() {
        if (dragState.staged) snapBack();
        state.lock = null;
        dragState.staged = false; dragState.dir = 0; dragState.nxtIndex = -1;
      }

      media.addEventListener('touchstart',  function(e) { onStart(e.touches[0].clientX, e.touches[0].clientY); },         { passive: true });
      media.addEventListener('touchmove',   function(e) { onMove(e.touches[0].clientX, e.touches[0].clientY, e); },       { passive: false });
      media.addEventListener('touchend',    function(e) { onEnd(e.changedTouches[0].clientX); },                           { passive: true });
      media.addEventListener('touchcancel', onCancel,                                                                       { passive: true });
    });
  }

  function staggerLoad() {
    document.querySelectorAll('.tmv2-card:not(.is-loaded)').forEach(function (card, i) {
      setTimeout(function () { card.classList.add('is-loaded'); }, i * 35);
    });
  }

  function init() {
    document.querySelectorAll(GRID_SELECTOR).forEach(initGrid);
    staggerLoad();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
